import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ElderFormFieldDenseDirective, ElderFormFieldLabelDirective } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkBatchState } from '../../../../../orders/batches/work-batch'

@Component({
  selector: 'app-batch-status-indicator',
  imports: [
    ElderTranslatePipe,
    MatFormField,
    MatLabel,
    MatInput,
    ElderFormFieldLabelDirective,
    ElderFormFieldDenseDirective,
  ],
  template: `
    <mat-form-field
      [floatLabel]="'always'"
      subscriptSizing="dynamic"
      elderFormFieldLabel
      elderDense
    >
      <mat-label>{{ 'context.state' | translate }}</mat-label>
      <input
        matInput
        name="workBatchState"
        readonly
        value="{{ 'WorkBatchState.' + workBatchState() | translate }}"
      />
    </mat-form-field>
  `,
})
export class BatchStatusIndicatorComponent {
  workBatchState = input.required<WorkBatchState>()
  WorkBatchState = WorkBatchState
}
